import InternalStorageBaseScreen from "../../../../mapping_tool/UpdateNodes/shared/internalStorage/InternalStorageBaseScreen";

export const InternalStorageBase = ({ modalData }: { modalData: any }) => (
  <InternalStorageBaseScreen modalData={modalData} gate="farm" variant="simulate" />
);
